import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Real Estate Registry List with Query (for remote operations)
export const getRealEstateRegistryListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REAL_ESTATE_REGISTRIES}?${stringifyParams(
			params
		)}`
	);
};

// Get Real Estate Registry List with Query
export const getRealEstateRegistryList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REAL_ESTATE_REGISTRIES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Real Estate Registry
export const getRealEstateRegistry = real_estate_registry_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REAL_ESTATE_REGISTRY}${real_estate_registry_id}`
	);
};

// Add New Real Estate Registry
export const addNewRealEstateRegistryApi = real_estate_registry => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_REAL_ESTATE_REGISTRY}`,
		real_estate_registry
	);
};

// Update Real Estate Registry
export const updateRealEstateRegistryApi = real_estate_registry => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_REAL_ESTATE_REGISTRY}${real_estate_registry._id}`,
		real_estate_registry
	);
};

// Delete Real Estate Registry
export const deleteRealEstateRegistryApi = real_estate_registry_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_REAL_ESTATE_REGISTRY}${real_estate_registry_id}`
	);
};

// Check if Real Estate Registry Exists
export const checkRealEstateRegistryExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_REAL_ESTATE_REGISTRY_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
